<template>
  <div class="common-card">
    <b-card class="top mb-0">
      <div class="d-flex flex-wrap align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <h4 class="font-weight-bolder text-nowrap mb-0">
            <font-awesome-icon class="mr-1" icon="fa-solid fa-pen-to-square" />
            修改記錄
          </h4>
          <div class="d-flex ml-3 align-items-center">
            <label>顯示</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>條目</label>
          </div>
        </div>
      </div>
    </b-card>

    <b-card no-body class="card-statistics bottom">
      <b-card-body class="p-2">
        <b-table
          ref="refEditRecordListTable"
          class="position-relative"
          :items="fetchEditRecords"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="未找到匹配的記錄"
          :sort-desc.sync="isSortDirDesc"
        >
          <template #cell(project_id)="data">
            {{ data.item.project && data.item.project.project_number }}
          </template>

          <template #cell(changed_data)="data">
            <div v-if="data.item.changed_data">
              <div
                class="d-flex logs-flex"
                v-for="(item, index) of Object.keys(data.item.changed_data)"
                :key="`changeItem${data.index}${index}`"
              >
                <template v-if="data.item.changed_data[item]">
                  <span class="title">{{ item }}：</span>
                  <span class="desc"
                    >{{ data.item.changed_data[item].old_value }} >
                    {{ data.item.changed_data[item].new_value }}</span
                  >
                </template>
              </div>
            </div>
          </template>

          <template #cell(project)="data">
            {{ data.item.project && data.item.project.project_name }}
          </template>
          <!-- Column:  -->
          <template #cell(user)="data">
            {{ data.item.user && data.item.user.name }}
          </template>
          <!-- Column: created_at -->
          <template #cell(created_at)="data">
            {{ getDateTime(data.item.created_at) }}
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >在{{ dataMeta.of }}個記錄中，正在顯示 {{ dataMeta.from }} 至
                {{ dataMeta.to }}個記錄</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRow"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
    
<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import useEditRecordsList from "./useEditRecordsList";

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
  },
  props: {
    inComponent: { type: [Number, Boolean], default: 0 },
  },
  data() {
    return {};
  },
  methods: {},
  setup(props) {
    const {
      fetchEditRecords,
      tableColumns,
      perPage,
      currentPage,
      totalRow,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      editRecordsList,
      refEditRecordListTable,
      refetchData,
      ability,
    } = useEditRecordsList(!!props.inComponent);

    return {
      fetchEditRecords,
      tableColumns,
      perPage,
      currentPage,
      totalRow,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      editRecordsList,
      refEditRecordListTable,
      refetchData,
      ability,
    };
  },
};
</script>
    
<style lang="scss" scoped>
.per-page-selector {
  width: 100px;
}
.logs-flex {
  margin-bottom: 0.25rem;
  .title {
    margin-right: 1rem;
    white-space: nowrap;
  }
  .desc {
    white-space: nowrap;
  }
}

// @media screen and (max-width: 768px) {

// }
// @media screen and (max-width: 575px) {

// }
</style>
    
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@/assets/scss/variables/_variables.scss";
</style>
    